package br.com.vvrefeicoes.portal.domain.model

data class JuridicoProcesso(
    val id: String,
    val empresaId: String,
    val empresaNome: String,
    val empresaCnpj: String,
    val numeroCnj: String,
    val tribunal: String,
    val orgaoVara: String,
    val assunto: String,
    val classe: String,
    val status: String,
    val autor: String,
    val reu: String,
    val juiz: String,
    val esfera: String,
    val rito: String,
    val instancia: String,
    val estrategico: Boolean,
    val valorCausa: Double?,
    val ultimaMovimentacao: String?,
    val linkExterno: String?,
    val unidades: List<JuridicoProcessoUnidade> = emptyList(),
)

data class JuridicoProcessoUnidade(
    val id: String,
    val nome: String,
)

data class JuridicoProcessoPage(
    val content: List<JuridicoProcesso>,
    val totalPages: Int,
)

data class JuridicoProcessoFilterOptions(
    val status: List<String>,
    val tribunais: List<String>,
)
